<template>
  <div class="mt-4">
    <vue-table :data="data" :headers="headers" :loading="loading" @change="onPagination">
      <template v-slot:index="{item}">
        {{ (item.index + 1) + ((data.current_page - 1) * data.per_page) }}
      </template>
    </vue-table>
  </div>
</template>

<script>
export default {
  name: "index",

  data: () => ({
    data: [],
    loading: false,
    headers: [
      {value: 'index', text: 'ردیف', sortable: false, align: 'center'},
      {value: 'title', text: 'عنوان', sortable: false, align: 'center'},
      {value: 'remind_date_p', text: 'زمان یادآوری', sortable: false, align: 'center'},
      // {value: 'reminder_at', text: 'تاریخ یادآوری', sortable: false, align: 'center'},
      {value: 'reference', text: 'منتشر کننده', sortable: false, align: 'center'},
      {value: 'user_id', text: 'ثبت کننده', sortable: false, align: 'center'},
      {value: 'action', text: 'مدیریت', sortable: false, align: 'center'},
    ],
    tableProps: {
      length: 10,
      page: 1
    }
  }),

  mounted() {
    this.fetch()
  },

  methods: {
    fetch() {
      this.loading = true

      this.requestApiGetState('user/reminder')
        .then(({data}) => this.data = data.data)
        .catch(({response}) => console.log('failed to get user reminders list: ', response))
        .finally(() => this.loading = false)
    },
    onPagination(e) {

    }
  }
}
</script>

<style scoped>

</style>